<template>
	<div id="div" style="display: flex;">
		<svg v-if="show" id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%">
			<defs />
			<g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="4f131acf" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="0" height="0" preserveAspectRatio="none"
							transform="translate(709.9923552254002, -3901.1410113000147)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/Rectangle 3399.558a635d.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="709.9923552254002" y="-3900.3956034839002" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="1cb0c310" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="192.74503921115817" height="150.8439437304716" preserveAspectRatio="none"
							transform="translate(236.2907933005639, -3571.9896145385237)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/Group 6266527.5f7901ff.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="580a7d22" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="124.15516618942618" height="93.80612556534422" preserveAspectRatio="none"
							transform="translate(1019.0373710247752, -3581.328305171847)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEIBENG.0fc02abf.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="27c34ad" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="126.38248879181018" height="220.5948895275232" preserveAspectRatio="none"
							transform="translate(548.1422725432553, -3961.661686506786)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEITONG.1faac2f9.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="611.3335169391604" y="-3850.6188339269097" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="72416990" name="mindNode" text="总阀">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 194.2798246165307 -3926.55505327937 L 254.30808090063678 -3926.55505327937 L 254.30808090063678 -3926.55505327937 A 16.36501982898365 16.36501982898365 0 0 1 270.67310072962044 -3910.190033450386 L 270.67310072962044 -3910.1900334503866 L 270.67310072962044 -3910.1900334503866 A 16.36501982898365 16.36501982898365 0 0 1 254.30808090063678 -3893.825013621403 L 194.2798246165307 -3893.825013621403 L 194.2798246165307 -3893.825013621403 A 16.36501982898365 16.36501982898365 0 0 1 177.91480478754704 -3910.1900334503866 L 177.91480478754704 -3910.190033450386 L 177.91480478754704 -3910.190033450386 A 16.36501982898365 16.36501982898365 0 0 1 194.2798246165307 -3926.55505327937"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="207.73395519999" y="-3909.030510180875" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">总阀
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="6d97d5e5" name="mindNode" text="水泵">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 432.11944650581535 -3904.8337211505236 L 492.1477027899215 -3904.8337211505236 L 492.1477027899215 -3904.8337211505236 A 16.36501982898365 16.36501982898365 0 0 1 508.5127226189051 -3888.46870132154 L 508.5127226189051 -3888.4687013215403 L 508.5127226189051 -3888.4687013215403 A 16.36501982898365 16.36501982898365 0 0 1 492.1477027899215 -3872.1036814925565 L 432.11944650581535 -3872.1036814925565 L 432.11944650581535 -3872.1036814925565 A 16.36501982898365 16.36501982898365 0 0 1 415.7544266768317 -3888.4687013215403 L 415.7544266768317 -3888.46870132154 L 415.7544266768317 -3888.46870132154 A 16.36501982898365 16.36501982898365 0 0 1 432.11944650581535 -3904.8337211505236"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="445.57357708927464" y="-3887.3091780520285" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">水泵
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="0daa21e" name="mindNode"
					text="开启过滤系统">
					<path fill="none" stroke="none" />
					<g>
						<path fill="rgb(18,130,255,0)" stroke="none" paint-order="stroke fill markers"
							d=" M 183.95350828213597 -3792.229953396289 L 294.8911163859847 -3792.229953396289 L 294.8911163859847 -3792.229953396289 A 16.88180992884631 16.88180992884631 0 0 1 311.772926314831 -3775.3481434674427 L 311.772926314831 -3775.348143467443 L 311.772926314831 -3775.348143467443 A 16.88180992884631 16.88180992884631 0 0 1 294.8911163859847 -3758.4663335385967 L 183.95350828213597 -3758.4663335385967 L 183.95350828213597 -3758.4663335385967 A 16.88180992884631 16.88180992884631 0 0 1 167.07169835328966 -3775.348143467443 L 167.07169835328966 -3775.3481434674427 L 167.07169835328966 -3775.3481434674427 A 16.88180992884631 16.88180992884631 0 0 1 183.95350828213597 -3792.229953396289"
							fill-opacity="1" />
					</g>
					<path fill="none" stroke="rgb(255,255,255)" paint-order="fill stroke markers"
						d=" M 183.95350828213597 -3792.229953396289 L 294.8911163859847 -3792.229953396289 L 294.8911163859847 -3792.229953396289 A 16.88180992884631 16.88180992884631 0 0 1 311.772926314831 -3775.3481434674427 L 311.772926314831 -3775.348143467443 L 311.772926314831 -3775.348143467443 A 16.88180992884631 16.88180992884631 0 0 1 294.8911163859847 -3758.4663335385967 L 183.95350828213597 -3758.4663335385967 L 183.95350828213597 -3758.4663335385967 A 16.88180992884631 16.88180992884631 0 0 1 167.07169835328966 -3775.348143467443 L 167.07169835328966 -3775.3481434674427 L 167.07169835328966 -3775.3481434674427 A 16.88180992884631 16.88180992884631 0 0 1 183.95350828213597 -3792.229953396289"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255,255,255)" stroke="none" font-family="微软雅黑 " font-size="16.564618135881556px"
							font-style="normal" font-weight="normal" text-decoration="normal" x="189.7423196582791"
							y="-3774.1886201979314" text-anchor="start" dominant-baseline="central"
							fill-opacity="1">开启过滤系统
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5f5104d" name="mindNode"
					text="吸肥阀4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 1042.4628068439858 -3707.853259127008 L 1102.491063128092 -3707.853259127008 L 1102.491063128092 -3707.853259127008 A 16.36501982898365 16.36501982898365 0 0 1 1118.8560829570756 -3691.4882392980244 L 1118.8560829570756 -3691.488239298025 L 1118.8560829570756 -3691.488239298025 A 16.36501982898365 16.36501982898365 0 0 1 1102.491063128092 -3675.123219469041 L 1042.4628068439858 -3675.123219469041 L 1042.4628068439858 -3675.123219469041 A 16.36501982898365 16.36501982898365 0 0 1 1026.0977870150023 -3691.488239298025 L 1026.0977870150023 -3691.4882392980244 L 1026.0977870150023 -3691.4882392980244 A 16.36501982898365 16.36501982898365 0 0 1 1042.4628068439858 -3707.853259127008"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="1042.7813401984413" y="-3690.328716028513" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">吸肥阀4
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="02fdc8c" name="mindNode" text="施肥泵">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 1102.8433418609995 -3599.955625097842 L 1162.8715981451057 -3599.955625097842 L 1162.8715981451057 -3599.955625097842 A 16.36501982898365 16.36501982898365 0 0 1 1179.2366179740893 -3583.5906052688583 L 1179.2366179740893 -3583.590605268859 L 1179.2366179740893 -3583.590605268859 A 16.36501982898365 16.36501982898365 0 0 1 1162.8715981451057 -3567.225585439875 L 1102.8433418609995 -3567.225585439875 L 1102.8433418609995 -3567.225585439875 A 16.36501982898365 16.36501982898365 0 0 1 1086.478322032016 -3583.590605268859 L 1086.478322032016 -3583.5906052688583 L 1086.478322032016 -3583.5906052688583 A 16.36501982898365 16.36501982898365 0 0 1 1102.8433418609995 -3599.955625097842"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="1108.017473665162" y="-3582.431081999347" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">施肥泵
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5169e6dc" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(536.589386371108,-3641.5831628882866) rotate(180,0,0) translate(-536.589386371108,3641.5831628882866)">
						<g>
							<image width="48.81450202695062" height="56.13667733099321" preserveAspectRatio="none"
								transform="translate(512.1821353576328, -3669.651501553783)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/XIFEIDIANCIFA.e5e802e8.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="bdf1800" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="824.7260484399056" height="24.4001789479262" preserveAspectRatio="none"
							transform="translate(429.03583251171386, -3469.0546690863466)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/7.e316eb6e.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5d616f65" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.920767037821463" height="32.3969971491679" preserveAspectRatio="none"
							transform="translate(455.56327340332547, -3497.7849319914626)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/8.f43db8bd.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5a266a17" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.607150901219057" height="30.758938626523825" preserveAspectRatio="none"
							transform="translate(1059.7336267752682, -3607.152584496613)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 13.20a4d574.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="045c7a0" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="76.98035089961215" height="24.8323712579394" preserveAspectRatio="none"
							transform="translate(1091.0883857621352, -3645.1249422506767)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 14.ccb19eab.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="1f38728" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.28662198362916" height="138.4337453066862" preserveAspectRatio="none"
							transform="translate(1181.560132546512, -3604.0539381436365)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 15.8bc95939.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="b7bf215" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.468925322148216" height="612.9465793198128" preserveAspectRatio="none"
							transform="translate(1231.5872029625084, -4078.0644736914637)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 16.f5c3c5d9.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="1243.8216656235827" y="-3770.8457762154426" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="59c3e3e" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3469.2496767052367)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="59f8162f" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3527.2445821504753)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="325fd01" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3703.713991206557)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="8dbc53b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -4056.652809318735)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="0d082f6" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -4115.475945670761)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="31518633" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1251.4941503475416,-4096.215966358158) rotate(180,0,0) translate(-1251.4941503475416,4096.215966358158)">
						<g>
							<image width="40.19478554487357" height="40.19478554487357" preserveAspectRatio="none"
								transform="translate(1231.3967575751049, -4116.313359130595)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="2d10d47e" name="gif"
					stroke="#222222" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="">
					<path fill="none" stroke="none" />
					<g />
					<g>
						<image width="0" height="0" preserveAspectRatio="none"
							transform="translate(1381.3931570636287, -3870.0855804599173)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/2.9337beff.gif" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="74f00ec8" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="218.0084838184898" height="150.75054732129612" preserveAspectRatio="none"
							transform="translate(186.98530227697188, -3754.5475151610653)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/一级过滤.dccbcd8d.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="295.9895441862168" y="-3678.426833684303" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3f37907" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(253.8978311855438,-3845.546129741729) rotate(90,0,0) translate(-253.8978311855438,3845.546129741729)">
						<g>
							<image width="80.3895710897401" height="62.804352413859455" preserveAspectRatio="none"
								transform="translate(213.70304564067374, -3876.9483059486593)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/总阀.4667513a.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="f57f5a4" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="48.23374265384823" height="48.23374265384823" preserveAspectRatio="none"
							transform="translate(1048.5458371901668, -3557.297475003627)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
					</g>
				</g>

				<g transform="translate(-137.39378989213762,4180.048161975308)" id="1700692e" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1079.268966034387,-3627.0991841687273) rotate(180,0,0) translate(-1079.268966034387,3627.0991841687273)">
						<g>
							<image width="39.24487865859363" height="39.24487865859363" preserveAspectRatio="none"
								transform="translate(1059.64652670509, -3646.721623498024)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="f1086d2" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3997.829672966706)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="611d6b4e" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3939.0065366146746)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3a3650c" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3880.18340026264)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="8ed1da5" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3821.360263910614)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="a6bace6" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3762.537127558593)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3ce1099d" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3644.890854854534)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="b17a059" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="298.916960567951" height="24.401384536159263" preserveAspectRatio="none"
							transform="translate(1253.476829324187, -3586.0677185025056)"
							xlink:href="https://drive.le5lecdn.com/2023/1030/1/1/组 17.5d736e5b.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="2e7bcc49" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-4115.97253418773) rotate(90,0,0) translate(-1425.3871787888932,4115.97253418773)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -4136.387320289271)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="9c10a29" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-4056.262656865515) rotate(90,0,0) translate(-1425.3871787888932,4056.262656865515)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -4076.6774429670563)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3a9cbbb" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3998.410605000339) rotate(90,0,0) translate(-1425.3871787888932,3998.410605000339)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -4018.82539110188)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="86b89aa" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3939.4101881812503) rotate(90,0,0) translate(-1425.3871787888932,3939.4101881812503)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3959.8249742827916)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="0c147a1" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3880.7801367580328) rotate(90,0,0) translate(-1425.3871787888932,3880.7801367580328)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3901.194922859574)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="9b73df" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3818.3608796062613) rotate(90,0,0) translate(-1425.3871787888932,3818.3608796062613)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3838.7756657078025)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3a9131" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3759.262405282842) rotate(90,0,0) translate(-1425.3871787888932,3759.262405282842)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3779.677191384383)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="a47d1c0" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3704.392530639751) rotate(90,0,0) translate(-1425.3871787888932,3704.392530639751)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3724.807316741292)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1425.3871787888932" y="-3703.6471228236364"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="7b4ee4f4" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3646.058594629606) rotate(90,0,0) translate(-1425.3871787888932,3646.058594629606)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3666.4733807311472)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1425.3871787888932" y="-3645.3131868134915"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="49a1f83" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3585.4451245099217) rotate(90,0,0) translate(-1425.3871787888932,3585.4451245099217)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3605.859910611463)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1425.3871787888932" y="-3584.699716693807"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="2366a8a9" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3526.9711642280286) rotate(90,0,0) translate(-1425.3871787888932,3526.9711642280286)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3547.38595032957)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1425.3871787888932" y="-3526.225756411914"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="61a33858" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1425.3871787888932,-3470.16154680758) rotate(90,0,0) translate(-1425.3871787888932,3470.16154680758)">
						<g>
							<image width="52.26185241994547" height="40.8295722030824" preserveAspectRatio="none"
								transform="translate(1399.2562525789203, -3490.5763329091214)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/PENLINDIANCIFA.99f3ebb5.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1425.3871787888932" y="-3469.4161389914657"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5e5f9aa9" name="mindNode"
					text="搅拌机4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="#278df8" paint-order="fill stroke markers"
						d=" M 810.4794477753261 -3953.562851320756 L 870.5077040594321 -3953.562851320756 L 870.5077040594321 -3953.562851320756 A 16.36501982898365 16.36501982898365 0 0 1 886.8727238884157 -3937.1978314917724 L 886.8727238884157 -3937.197831491773 L 886.8727238884157 -3937.197831491773 A 16.36501982898365 16.36501982898365 0 0 1 870.5077040594321 -3920.832811662789 L 810.4794477753261 -3920.832811662789 L 810.4794477753261 -3920.832811662789 A 16.36501982898365 16.36501982898365 0 0 1 794.1144279463424 -3937.197831491773 L 794.1144279463424 -3937.1978314917724 L 794.1144279463424 -3937.1978314917724 A 16.36501982898365 16.36501982898365 0 0 1 810.4794477753261 -3953.562851320756"
						stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="810.7979811297814" y="-3936.038308222261" text-anchor="start"
							dominant-baseline="central">搅拌机2
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="1f468435" name="mindNode"
					text="搅拌机4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 966.9622290526617 -3955.8681449606206 L 1026.9904853367677 -3955.8681449606206 L 1026.9904853367677 -3955.8681449606206 A 16.36501982898365 16.36501982898365 0 0 1 1043.3555051657513 -3939.503125131637 L 1043.3555051657513 -3939.5031251316373 L 1043.3555051657513 -3939.5031251316373 A 16.36501982898365 16.36501982898365 0 0 1 1026.9904853367677 -3923.1381053026535 L 966.9622290526617 -3923.1381053026535 L 966.9622290526617 -3923.1381053026535 A 16.36501982898365 16.36501982898365 0 0 1 950.597209223678 -3939.5031251316373 L 950.597209223678 -3939.503125131637 L 950.597209223678 -3939.503125131637 A 16.36501982898365 16.36501982898365 0 0 1 966.9622290526617 -3955.8681449606206"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="967.280762407117" y="-3938.3436018621255" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">搅拌机3
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="55942aa" name="mindNode"
					text="搅拌机4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 1130.8050598227767 -3951.755620112394 L 1190.8333161068829 -3951.755620112394 L 1190.8333161068829 -3951.755620112394 A 16.36501982898365 16.36501982898365 0 0 1 1207.1983359358665 -3935.39060028341 L 1207.1983359358665 -3935.3906002834105 L 1207.1983359358665 -3935.3906002834105 A 16.36501982898365 16.36501982898365 0 0 1 1190.8333161068829 -3919.0255804544267 L 1130.8050598227767 -3919.0255804544267 L 1130.8050598227767 -3919.0255804544267 A 16.36501982898365 16.36501982898365 0 0 1 1114.440039993793 -3935.3906002834105 L 1114.440039993793 -3935.39060028341 L 1114.440039993793 -3935.39060028341 A 16.36501982898365 16.36501982898365 0 0 1 1130.8050598227767 -3951.755620112394"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="1131.1235931772321" y="-3934.231077013899" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">搅拌机4
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5f6e683" name="mindNode"
					text="搅拌机4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 644.1182234927306 -3955.947109669713 L 704.1464797768366 -3955.947109669713 L 704.1464797768366 -3955.947109669713 A 16.36501982898365 16.36501982898365 0 0 1 720.5114996058203 -3939.582089840729 L 720.5114996058203 -3939.5820898407296 L 720.5114996058203 -3939.5820898407296 A 16.36501982898365 16.36501982898365 0 0 1 704.1464797768366 -3923.217070011746 L 644.1182234927306 -3923.217070011746 L 644.1182234927306 -3923.217070011746 A 16.36501982898365 16.36501982898365 0 0 1 627.753203663747 -3939.5820898407296 L 627.753203663747 -3939.582089840729 L 627.753203663747 -3939.582089840729 A 16.36501982898365 16.36501982898365 0 0 1 644.1182234927306 -3955.947109669713"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="644.436756847186" y="-3938.422566571218" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">搅拌机1
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="7125b28" name="mindNode"
					text="吸肥阀4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 564.812266776736 -3707.853259127008 L 624.840523060842 -3707.853259127008 L 624.840523060842 -3707.853259127008 A 16.36501982898365 16.36501982898365 0 0 1 641.2055428898257 -3691.4882392980244 L 641.2055428898257 -3691.488239298025 L 641.2055428898257 -3691.488239298025 A 16.36501982898365 16.36501982898365 0 0 1 624.840523060842 -3675.123219469041 L 564.812266776736 -3675.123219469041 L 564.812266776736 -3675.123219469041 A 16.36501982898365 16.36501982898365 0 0 1 548.4472469477523 -3691.488239298025 L 548.4472469477523 -3691.4882392980244 L 548.4472469477523 -3691.4882392980244 A 16.36501982898365 16.36501982898365 0 0 1 564.812266776736 -3707.853259127008"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="565.1308001311913" y="-3690.328716028513" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">吸肥阀1
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="66baf2" name="mindNode" text="吸肥阀4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 884.1253966246942 -3707.853259127008 L 944.1536529088002 -3707.853259127008 L 944.1536529088002 -3707.853259127008 A 16.36501982898365 16.36501982898365 0 0 1 960.5186727377838 -3691.4882392980244 L 960.5186727377838 -3691.488239298025 L 960.5186727377838 -3691.488239298025 A 16.36501982898365 16.36501982898365 0 0 1 944.1536529088002 -3675.123219469041 L 884.1253966246942 -3675.123219469041 L 884.1253966246942 -3675.123219469041 A 16.36501982898365 16.36501982898365 0 0 1 867.7603767957105 -3691.488239298025 L 867.7603767957105 -3691.4882392980244 L 867.7603767957105 -3691.4882392980244 A 16.36501982898365 16.36501982898365 0 0 1 884.1253966246942 -3707.853259127008"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="884.4439299791495" y="-3690.328716028513" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">吸肥阀2
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="4f3d220d" name="mindNode"
					text="吸肥阀4">
					<path fill="none" stroke="none" />
					<g>
						<path fill="none" stroke="none" />
					</g>
					<path fill="none" stroke="rgb(255, 255, 255)" paint-order="fill stroke markers"
						d=" M 728.0138368679719 -3707.853259127008 L 788.0420931520779 -3707.853259127008 L 788.0420931520779 -3707.853259127008 A 16.36501982898365 16.36501982898365 0 0 1 804.4071129810616 -3691.4882392980244 L 804.4071129810616 -3691.488239298025 L 804.4071129810616 -3691.488239298025 A 16.36501982898365 16.36501982898365 0 0 1 788.0420931520779 -3675.123219469041 L 728.0138368679719 -3675.123219469041 L 728.0138368679719 -3675.123219469041 A 16.36501982898365 16.36501982898365 0 0 1 711.6488170389882 -3691.488239298025 L 711.6488170389882 -3691.4882392980244 L 711.6488170389882 -3691.4882392980244 A 16.36501982898365 16.36501982898365 0 0 1 728.0138368679719 -3707.853259127008"
						stroke-opacity="1" stroke-linecap="square" stroke-miterlimit="10" stroke-dasharray="" />
					<g>
						<text fill="rgb(255, 255, 255)" stroke="none" font-family="微软雅黑 "
							font-size="16.564618135881556px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="728.3323702224272" y="-3690.328716028513" text-anchor="start"
							dominant-baseline="central" fill-opacity="1">吸肥阀3
						</text>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3f134f91" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="220.90096459012983" height="243.49310869593856" preserveAspectRatio="none"
							transform="translate(216.35706844810989, -4170.048161975308)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/蓄水池.4ec4de9e.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="326.80755074317483" y="-4047.5561998112244" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="1e658bac" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="37.65509547053944" height="25.417189442614127" preserveAspectRatio="none"
							transform="translate(180.3459054597779, -4003.748568146912)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/1.8bb65639.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="18cf47fd" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.545359865675756" height="108.18140088945981" preserveAspectRatio="none"
							transform="translate(150.90484939400892, -3963.466828098985)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/2.e8675d26.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="eb101f1" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(171.0371033136362,-3983.6182944655598) rotate(180,0,0) translate(-171.0371033136362,3983.6182944655598)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(150.88563694706244, -4003.7697608321337)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="481592c8" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="37.65509547053944" height="25.417189442614127" preserveAspectRatio="none"
							transform="translate(187.22390602555606, -3840.595584998543)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/1.8bb65639.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="274482a" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(171.0371033136362,-3835.1339608429466) rotate(90,0,0) translate(-171.0371033136362,3835.1339608429466)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(150.88563694706244, -3855.2854272095205)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="235a1de" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="37.65509547053944" height="25.417189442614127" preserveAspectRatio="none"
							transform="translate(414.5790918555555, -3840.595584998543)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/1.8bb65639.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="6abc5aa0" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(466.82664109369557,-3819.8094443103596) rotate(270,0,0) translate(-466.82664109369557,3819.8094443103596)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(446.67517472712177, -3839.9609106769335)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="1f79f0c" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(476.2032573732807,-3780.6402837043242) rotate(90,0,0) translate(-476.2032573732807,3780.6402837043242)">
						<g>
							<image width="37.65509547053944" height="25.417189442614127" preserveAspectRatio="none"
								transform="translate(457.37570963801096, -3793.3488784256315)"
								xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/1.8bb65639.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="bf96234" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(374.7264943952973,-3870.447219678964) rotate(90,0,0) translate(-374.7264943952973,3870.447219678964)">
						<g>
							<image width="125.32043919401607" height="91.58032094947329" preserveAspectRatio="none"
								transform="translate(312.06627479828927, -3916.2373801537)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/水泵.10cebf2f.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="52b947b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="36.17530699038616" height="36.17530699038616" preserveAspectRatio="none"
							transform="translate(356.63884090010475, -3876.770891988927)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3bb838d" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="44.625899033397516" height="25.223334236268162" preserveAspectRatio="none"
							transform="translate(285.29821251273, -3840.4017297921946)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/4.8e73a7a1.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="79fe32" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(171.0371033136362,-3618.504843548699) rotate(180,0,0) translate(-171.0371033136362,3618.504843548699)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(150.88563694706244, -3638.6563099152727)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="7bad6018" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(171.07701287855323,-3438.0635644859362) rotate(90,0,0) translate(-171.07701287855323,3438.0635644859362)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(150.92554651197946, -3458.21503085251)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5485c605" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="44.625899033397516" height="25.223334236268162" preserveAspectRatio="none"
							transform="translate(192.00517900945198, -3443.54761241718)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/4.8e73a7a1.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="9b66c4" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(532.4482318371375,-3804.331332547553) rotate(180,0,0) translate(-532.4482318371375,3804.331332547553)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(512.2967654705639, -3824.4827989141268)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="c841007" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="57.394831008164644" height="23.316650097066887" preserveAspectRatio="none"
							transform="translate(390.43899242214354, -3745.9135021637912)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/4.11a0562c.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="076dddf" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(467.6548720004895,-3741.9200875265037) rotate(360,0,0) translate(-467.6548720004895,3741.9200875265037)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(447.5034056339157, -3762.0715538930776)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="2cefa3b" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="25.714462311670676" height="140.44052493297062" preserveAspectRatio="none"
							transform="translate(150.9297544573427, -3598.757621828133)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/5.1b9e22f4.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3cc35db8" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="535.6562763638663" height="25.695688534060004" preserveAspectRatio="none"
							transform="translate(483.1415452074338, -3537.9095908912686)"
							xlink:href="https://drive.le5lecdn.com/2023/1103/1/1/6.faefbfb2.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="df9e255" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(475.51131715297026,-3517.547339946653) rotate(180,0,0) translate(-475.51131715297026,3517.547339946653)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(455.35985078639646, -3537.698806313227)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="3b6489" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1185.1725075996892,-3623.7017375961914) rotate(270,0,0) translate(-1185.1725075996892,3623.7017375961914)">
						<g>
							<image width="38.92752095248146" height="38.92752095248146" preserveAspectRatio="none"
								transform="translate(1165.7087471234486, -3643.165498072432)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1185.1725075996892" y="-3622.956329780077"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="6b8178a" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.576712557184923" height="117.21201373426655" preserveAspectRatio="none"
							transform="translate(512.6041956275103, -3784.179866180976)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/7.f1ae877f.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="5a097c3" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.15860801391808" height="82.6967735861042" preserveAspectRatio="none"
							transform="translate(513.945334201846, -3616.702378772228)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/8.cc1604b7.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="14e59bba" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(697.0037054877888,-3641.6744306242185) rotate(180,0,0) translate(-697.0037054877888,3641.6744306242185)">
						<g>
							<image width="48.81450202695062" height="56.13667733099321" preserveAspectRatio="none"
								transform="translate(672.5964544743134, -3669.742769289715)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/XIFEIDIANCIFA.e5e802e8.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="697.0037054877888" y="-3640.9290228081036"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="10bdacf" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(695.3472436742006,-3804.4226002834866) rotate(180,0,0) translate(-695.3472436742006,3804.4226002834866)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(675.1957773076269, -3824.5740666500606)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="a10bed" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.576712557184923" height="117.21201373426655" preserveAspectRatio="none"
							transform="translate(674.6749765577792, -3784.271133916912)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/7.f1ae877f.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="53a8a09d" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.15860801391808" height="82.6967735861042" preserveAspectRatio="none"
							transform="translate(676.0161151321145, -3616.793646508164)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/8.cc1604b7.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="4e6b497" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(855.7443803207176,-3641.7967245388772) rotate(180,0,0) translate(-855.7443803207176,3641.7967245388772)">
						<g>
							<image width="48.81450202695062" height="56.13667733099321" preserveAspectRatio="none"
								transform="translate(831.3371293072422, -3669.8650632043737)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/XIFEIDIANCIFA.e5e802e8.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="855.7443803207176" y="-3641.0513167227623"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="321ab49" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(854.0879185071292,-3804.544894198152) rotate(180,0,0) translate(-854.0879185071292,3804.544894198152)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(833.9364521405555, -3824.696360564726)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="312bec9" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.576712557184923" height="117.21201373426655" preserveAspectRatio="none"
							transform="translate(833.415651390708, -3784.3934278315755)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/7.f1ae877f.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="b67b656" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.15860801391808" height="82.6967735861042" preserveAspectRatio="none"
							transform="translate(834.7567899650435, -3616.915940422825)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/8.cc1604b7.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="2f45fcf7" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1013.6888277020697,-3641.7967245388977) rotate(180,0,0) translate(-1013.6888277020697,3641.7967245388977)">
						<g>
							<image width="48.81450202695062" height="56.13667733099321" preserveAspectRatio="none"
								transform="translate(989.2815766885943, -3669.865063204394)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/XIFEIDIANCIFA.e5e802e8.svg" />
						</g>
						<g>
							<text fill="#222222" stroke="none"
								font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
								font-size="9.938770881528935px" font-style="normal" font-weight="normal"
								text-decoration="normal" x="1013.6888277020697" y="-3641.0513167227828"
								text-anchor="start" dominant-baseline="central" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="d037d4" name="image">
					<path fill="none" stroke="none" d="" />
					<g
						transform="translate(1012.0323658884815,-3804.544894198152) rotate(180,0,0) translate(-1012.0323658884815,3804.544894198152)">
						<g>
							<image width="40.30293273314755" height="40.30293273314755" preserveAspectRatio="none"
								transform="translate(991.8808995219078, -3824.696360564726)"
								xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/le5le.meta2d(2).28a2ce80.svg" />
						</g>
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="6e5da177" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.576712557184923" height="117.21201373426655" preserveAspectRatio="none"
							transform="translate(991.3600987720606, -3784.3934278315755)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/7.f1ae877f.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="6590fc4" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="24.15860801391808" height="82.6967735861042" preserveAspectRatio="none"
							transform="translate(992.7012373463951, -3616.9159404228426)"
							xlink:href="https://drive.le5lecdn.com/2023/1106/1/1/8.cc1604b7.svg" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="154c8e75" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="126.38248879181018" height="220.5948895275232" preserveAspectRatio="none"
							transform="translate(706.6867771784825, -3961.661686506786)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEITONG.1faac2f9.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="769.8780215743876" y="-3850.6188339269097" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="56cd9896" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="126.38248879181018" height="220.5948895275232" preserveAspectRatio="none"
							transform="translate(865.2312818137101, -3961.661686506786)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEITONG.1faac2f9.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="928.4225262096152" y="-3850.6188339269097" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
				<g transform="translate(-137.39378989213762,4180.048161975308)" id="4a5f21ff" name="image">
					<path fill="none" stroke="none" />
					<g>
						<image width="126.38248879181018" height="220.5948895275232" preserveAspectRatio="none"
							transform="translate(1023.7757864489379, -3961.661686506786)"
							xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/SHIFEITONG.1faac2f9.svg" />
					</g>
					<g>
						<text fill="#222222" stroke="none"
							font-family="&quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial "
							font-size="9.938770881528935px" font-style="normal" font-weight="normal"
							text-decoration="normal" x="1086.9670308448428" y="-3850.6188339269097" text-anchor="start"
							dominant-baseline="central" />
					</g>
				</g>
			</g>
			<g transform="translate(26.781578058649192,4283.304667291171)" id="d9a8b30" name="image">
				<path fill="none" stroke="none" />
				<g>
					<image width="69.90272683112276" height="69.90272683112276" preserveAspectRatio="none"
						transform="translate(402.4716505624995, -3937.562235252014)"
						xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
				</g>
			</g>
			<g transform="translate(26.781578058649192,4283.304667291171)" id="bf6bbe" name="image">
				<path fill="none" stroke="none" />
				<g>
					<image width="69.90272683112276" height="69.90272683112276" preserveAspectRatio="none"
						transform="translate(560.7038352129703, -3936.7340043452195)"
						xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
				</g>
			</g>
			<g transform="translate(26.781578058649192,4283.304667291171)" id="b1b4fea" name="image">
				<path fill="none" stroke="none" />
				<g>
					<image width="69.90272683112276" height="69.90272683112276" preserveAspectRatio="none"
						transform="translate(719.6088431802057, -3937.391022870591)"
						xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
				</g>
			</g>
			<g transform="translate(26.781578058649192,4283.304667291171)" id="71d91b59" name="image">
				<path fill="none" stroke="none" />
				<g>
					<image width="69.90272683112276" height="69.90272683112276" preserveAspectRatio="none"
						transform="translate(877.879856300292, -3938.1245689241896)"
						xlink:href="https://drive.le5lecdn.com/2023/1027/1/1/下载 (2) 1.d907bf88.svg" />
				</g>
			</g>
		</svg>
		<div class=""
			style="width: 50px;position: relative;left: -20px;padding: 30px 0 20px 0;font-size: 12px;display: flex;flex-direction: column;justify-content: space-between;">
			<div v-for="item in fertilizerMassifName" :key="item.id">
				{{ item.massif }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "app",
		components: {},
		props: {
			fertilizerDeviceListOptFor: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				show: true,
				fertilizerMassifName: [],
			};
		},
		watch: {
			'fertilizerDeviceListOptFor': {
				// newVal, oldVal
				handler: function(newVal) {
					// 监听到fertilizerDeviceListOptFor变化后的操作
					// 可以在这里调用loadingEvent和newDataList等方法
					console.log('fourAisle---newVal',newVal)
					// console.log('oldVal',oldVal)
					this.fertilizerMassifName = JSON.parse(newVal.fertilizerMassifName);
					this.show = false;
					let that = this;
					setTimeout(function() {
						that.show = true;
						setTimeout(function() {
							that.setSVGViewBox();
							that.getFertilizerDevices();
						}, 10);
					}, 1);
				},
				deep: true // 深度监听对象内部值的变化
			}
			// fertilizerDeviceListOptFor(item) {
			// 	console.log("fertilizerDeviceListOptFor", item)
			// 	this.show = false;
			// 	let that = this;
			// 	setTimeout(function() {
			// 		that.show = true;
			// 		setTimeout(function() {
			// 			that.setSVGViewBox();
			// 			that.getFertilizerDevices();
			// 		}, 10);
			// 	}, 1);

			// }
		},
		async mounted() {
			console.log('====================fourAisle')
			this.fertilizerMassifName = JSON.parse(this.fertilizerDeviceListOptFor.fertilizerMassifName);
			// console.log('====================fourAisle', this.fertilizerMassifName)
			this.$forceUpdate();
			let that = this;
			that.setSVGViewBox();
			that.getFertilizerDevices();
			window.addEventListener('resize', this.setSVGViewBox)
		},
		methods: {
			/* 查水肥实时数据 */
			async getFertilizerDevices() {
				this.$emit('loadingEvent', true);
				let httpData = {
					deviceId: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
					queueType: 1,
					queueld: ''
				};
				console.log("getRealTimeDeviceDataReadingsArray-httpData", httpData);
				this.$axios.post("/DeviceMqttPushApi/RealTimeDeviceDataReadingsArray", httpData).then((res) => {
					console.log("getRealTimeDeviceDataReadingsArray-res", res);
					if (res.msg == '操作成功') {
						let newDataList = []
						newDataList = newDataList.concat(res.data.sequence4, res.data.sequence5, res.data
							.sequence6, res.data.sequence7, res.data.sequence8, res.data.sequence9, res
							.data.sequence10, res.data.sequence11);
						this.$emit('sonDataList', newDataList);
						console.log("getRealTimeDeviceDataReadingsArray-res操作成功", newDataList);
						for (let i = 0; i < newDataList.length; i++) {
							if (newDataList[i].pointVue == '0066') {
								console.log('操作成功0066', newDataList[i].result)
								this.getSwitchRecording(newDataList[i].result, 0);
							}

							if (newDataList[i].pointVue == '0067') {
								console.log('操作成功0067', newDataList[i].result)
								this.getSwitchRecording(newDataList[i].result, 1);
							}

							if (newDataList[i].pointVue == '0068') {
								console.log('操作成功0068', newDataList[i].result)
								this.getSwitchRecording(newDataList[i].result, 2);
							}

						}

					}
					// uni.hideLoading();

					if (res.code == 500) {
						this.$axios.post("/DeviceMqttPushApi/clearQueue", {
							deviceId: this.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
						}).then((res) => {
							console.log("clearQueue-清空后重查---", res);
							this.getFertilizerDevices();
						}).catch((error) => {
							console.log("clearQueue-error---", error);
							// uni.hideLoading();
						});
					}

				}).catch((error) => {
					console.log("getRealTimeDeviceDataReadingsArray-error", error);
				});
			},
			async getFertilizerDevicessss() {
				this.$emit('loadingEvent', true);
				console.log("执行查询")
				let that = this;
				let httpData = {
					deviceId: that.fertilizerDeviceListOptFor.fertilizerDeviceNumber,
					mark: 'WT_DS_Y_001'
				}
				let data = await that.$axios.post('/DeviceMqttPushApi/RealTimeDeviceDataReading', httpData).then(
					async (res) => {
						console.log("res", res)
						if (res.data) {
							for (let i = 0; i < res.data.length; i++) {
								if (res.data[i].hothouseDeviceDataType == '0066') {
									let number = that.decimalToBinary(res.data[i].hothouseDeviceDataVal);
									let state = that.padTo15Digits(number);
									that.getSwitchRecording(state, 0);
								} else if (res.data[i].hothouseDeviceDataType == '0067') {
									let number = that.decimalToBinary(res.data[i].hothouseDeviceDataVal);
									let state = that.padTo15Digits(number);
									that.getSwitchRecording(state, 1);
								} else if (res.data[i].hothouseDeviceDataType == '0068') {
									let number = that.decimalToBinary(res.data[i].hothouseDeviceDataVal);
									let state = that.padTo15Digits(number);
									that.getSwitchRecording(state, 2);
								}
							}
						} else {
							// res.msg
							// this.$message.error(res.msg);
						}
					})
				console.log("data", data)

			},
			getSwitchRecording(number, type) {
				// console.log("getSwitchRecording-number", number)
				console.log("getSwitchRecording-type", type)
				let switchVal = number.split('').map(Number);
				console.log("getSwitchRecording-switchVal", switchVal)
				let svg = '';
				let image = '';
				let that = this;
				if (type == 0) {
					//3水泵启停给定
					if (switchVal[16 - 9] == 1) {
						let list = [{
							id: '52b947b',
							img: 'https://drive.le5lecdn.com/2023/1027/1/1/下载 (2).360789ef.gif'
						}, {
							id: '1e658bac',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
						}, {
							id: '18cf47fd',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
						}, {
							id: '481592c8',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/3.89eb0239.gif'
						}, {
							id: '3bb838d',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
						}, {
							id: '235a1de',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/3.89eb0239.gif'
						}, {
							id: '1f79f0c',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/30.cbc08d5b.gif'
						}, {
							id: 'c841007',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
						}, {
							id: '2cefa3b',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/10.ed5a8ed5.gif'
						}, {
							id: '5485c605',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/1.5f631308.gif'
						}, {
							id: 'bdf1800',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/6.f3d883c9.gif'
						}, {
							id: 'b7bf215',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/11.031b9afa.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//4搅拌泵1启停给定
					if (switchVal[16 - 10] == 1) {
						let list = [{
							id: 'd9a8b30',
							img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					if (that.fertilizerDeviceListOptFor.fertilizerDeviceType != 1) {
						//4搅拌泵2启停给定
						if (switchVal[16 - 11] == 1) {
							let list = [{
								id: 'bf6bbe',
								img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//4搅拌泵3启停给定
						if (switchVal[16 - 12] == 1) {
							let list = [{
								id: 'b1b4fea',
								img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//4搅拌泵4启停给定
						if (switchVal[16 - 13] == 1) {
							let list = [{
								id: '71d91b59',
								img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
					}
					//12施肥泵启停给定
					if (switchVal[16 - 14] == 1) {
						let list = [{
							id: 'f57f5a4',
							img: 'https://drive.le5lecdn.com/2023/1123/1/1/下载 (2).37f1c27e.gif'
						}, {
							id: '5d616f65',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/30.cbc08d5b.gif'
						}, {
							id: '3cc35db8',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/7.707b5543.gif'
						}, {
							id: '5a266a17',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/30.cbc08d5b.gif'
						}, {
							id: '045c7a0',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/2.efdd61a4.gif'
						}, {
							id: '1f38728',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/10.ed5a8ed5.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//8吸肥电磁阀1启停给定
					if (switchVal[16 - 15] == 1) {
						let list = [{
							id: '6b8178a',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
						}, {
							id: '5a097c3',
							img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					if (that.fertilizerDeviceListOptFor.fertilizerDeviceType != 1) {
						//4搅拌泵2启停给定
						if (switchVal[16 - 16] == 1) {
							let list = [{
								id: 'a10bed',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
							}, {
								id: '53a8a09d',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//4搅拌泵3启停给定
						if (switchVal[16 - 1] == 1) {
							let list = [{
								id: '312bec9',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
							}, {
								id: 'b67b656',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//4搅拌泵4启停给定
						if (switchVal[16 - 2] == 1) {
							let list = [{
								id: '6e5da177',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
							}, {
								id: '6590fc4',
								img: 'https://drive.le5lecdn.com/2024/0126/1/1/4.b47b5dcf.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
					}
					//13电磁阀1启停给定
					if (switchVal[16 - 3] == 1) {
						let list = [{
							id: '0d082f6',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//14电磁阀2启停给定
					if (switchVal[16 - 4] == 1) {
						let list = [{
							id: '8dbc53b',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//15电磁阀3启停给定
					if (switchVal[16 - 5] == 1) {
						let list = [{
							id: 'f1086d2',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//16电磁阀4启停给定
					if (switchVal[16 - 6] == 1) {
						let list = [{
							id: '611d6b4e',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}
					//17电磁阀5启停给定
					if (switchVal[16 - 7] == 1) {
						let list = [{
							id: '3a3650c',
							img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
						}]
						for (let i = 0; i < list.length; i++) {
							svg = document.getElementById(list[i].id);
							image = svg.querySelector('image');
							image.setAttribute('xlink:href', list[i].img);
						}
					}

					if (that.fertilizerDeviceListOptFor.fertilizerDeviceType != 1) {
						//18电磁阀6启停给定
						if (switchVal[16 - 8] == 1) {
							let list = [{
								id: '8ed1da5',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
					}
				}
				if (type == 1) {
					if (that.fertilizerDeviceListOptFor.fertilizerDeviceType != 1) {
						//19电磁阀7启停给定
						if (switchVal[16 - 9] == 1) {
							let list = [{
								id: 'a6bace6',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//20电磁阀8启停给定
						if (switchVal[16 - 10] == 1) {
							let list = [{
								id: '325fd01',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//21电磁阀9启停给定
						if (switchVal[16 - 11] == 1) {
							let list = [{
								id: '3ce1099d',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//22电磁阀10启停给定
						if (switchVal[16 - 12] == 1) {
							let list = [{
								id: 'b17a059',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//23电磁阀11启停给定
						if (switchVal[16 - 13] == 1) {
							let list = [{
								id: '59f8162f',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
						//24电磁阀12启停给定
						if (switchVal[16 - 14] == 1) {
							let list = [{
								id: '59c3e3e',
								img: 'https://drive.le5lecdn.com/2024/0127/1/1/12.73d34c9c.gif'
							}]
							for (let i = 0; i < list.length; i++) {
								svg = document.getElementById(list[i].id);
								image = svg.querySelector('image');
								image.setAttribute('xlink:href', list[i].img);
							}
						}
					}
				}
				that.$emit('loadingEvent', false);
			},
			decimalToBinary(decimal) {
				return (decimal >>> 0).toString(2);
			},
			padTo15Digits(number) {
				return number.toString().padStart(16, '0');
			},
			setSVGViewBox() {
				var divElement = document.getElementById("div");
				var svgElement = document.getElementById("svg");
				var divWidth = divElement.offsetWidth;
				var divHeight = divElement.offsetHeight;
				// console.log("divWidth", divWidth)
				// console.log("divHeight", divHeight)
				// var magnification = 0;
				var viewBoxWidth = 770;
				var viewBoxHeight = 770;
				var divAspectRatio = divWidth / divHeight;
				var viewBoxAspectRatio = viewBoxWidth / viewBoxHeight;
				var diff = '';
				if (divAspectRatio > viewBoxAspectRatio) {
					diff = (divWidth - divHeight * viewBoxAspectRatio) / 2;
					svgElement.setAttribute("viewBox", diff + " 0 " + (viewBoxWidth + diff) + " " + viewBoxHeight);
					// console.log("difffff", diff)
				} else {
					diff = (divHeight - divWidth / viewBoxAspectRatio) / 2;
					svgElement.setAttribute("viewBox", "0 " + diff + " " + viewBoxWidth + " " + (viewBoxHeight + diff));
				}
			},
		},
	};
</script>

<style scoped>

</style>